import { getTagsAndConditions } from "./getTagsAndConditions";

// Categorizes tags to make sections
export function getSubscriptionTagsByCategory(publication) {
  if (publication?.id === "from-qs") {
    return Object.fromEntries(publication.tagsByCategory);
  }

  const { tags, conditions } = getTagsAndConditions(publication);
  const { regionsTags, tagSections, multipleCategoriesTagSections, reportTitlesTags } = tags;
  const {
    isTxCategoriesEmpty,
    isCompaniesEmpty,
    isAnalystsEmpty,
    isEquityCategory,
    isMultipleCategories,
    isFiCategory,
    isSectorUpdateSubCategory,
    isCompanyUpdateSubCategory,
    isModelsSubCategory,
    hasPrimaryPeriodicals,
    isCompanyQuickNote
  } = conditions;

  /* eslint-disable no-unused-vars */
  if (isModelsSubCategory && !isTxCategoriesEmpty) {
    const { Sectors, ...finalTagSections } = tagSections;

    if (hasPrimaryPeriodicals) {
      return finalTagSections;
    }

    if (isCompaniesEmpty && isAnalystsEmpty) {
      return {
        Periodicals: reportTitlesTags
      };
    }

    const { Companies, Analysts } = tagSections;

    return {
      Companies,
      Analysts
    };
  }

  if (isMultipleCategories) {
    if (hasPrimaryPeriodicals) {
      return multipleCategoriesTagSections;
    }

    const { Periodicals, ...finalTagSections } = multipleCategoriesTagSections;

    return {
      ...finalTagSections,
      Periodicals: reportTitlesTags
    };
  }

  if (isEquityCategory) {
    // SUBCATEGORY FLASH, NOT SECTOR UPDATE, REPORT TYPE COMPANY QUICK NOTE
    // COMPANY QUICK NOTE: 1290352
    // COMPANY UPDATE: 1290344

    if (isCompanyQuickNote || isCompanyUpdateSubCategory) {
      const { Periodicals, Sectors, ...finalTagSections } = tagSections;
      return finalTagSections;
    }

    // SUBCATEGORY SECTOR UPDATE
    if (isSectorUpdateSubCategory) {
      if (hasPrimaryPeriodicals) {
        // 1171564
        return tagSections;
      }

      // NO PRIMARY PERIODICALS - 1273097
      const { Periodicals, ...finalTagSections } = tagSections;

      return {
        ...finalTagSections,
        Periodicals: reportTitlesTags
      };
    }

    // Default case for Equity
    const { Regions, Sectors, ...finalTagSections } = tagSections;

    if (hasPrimaryPeriodicals) {
      return finalTagSections;
    }

    return {
      ...finalTagSections,
      Periodicals: reportTitlesTags
    };
  }

  // CATEGORIES FI, FX, EC
  if (isFiCategory) {
    if (hasPrimaryPeriodicals) {
      // 6229300 EC,  6228242 SP, for other categories, just go to the tab
      const { Companies, Sectors, ...finalTagSections } = tagSections;
      return finalTagSections;
    }

    // 6229083 EC
    const { Companies, Sectors, ...finalTagSections } = tagSections;
    return {
      ...finalTagSections,
      Periodicals: reportTitlesTags,
      Regions: regionsTags
    };
  }

  if (isTxCategoriesEmpty) {
    // No tags - 6226834
    // Has both Equity and FI - 6227112
    if (hasPrimaryPeriodicals) {
      return tagSections;
    }
    const { Periodicals, ...finalTagSections } = tagSections;
    return {
      ...finalTagSections,
      Periodicals: reportTitlesTags
    };
  }

  // Edge case no tags
  return {
    "Available Tags": false
  };
}
